function History() {
  return <div>Not Implemented yet! Tehee :)</div>;
}

export default History;
